<template>
  <v-row justify="center" no-gutters>
    <v-card max-width="500">
      <v-card-title>
        <div>
          <h3 class="headline mb-0 primary--text"></h3>
          <h3 class="headline mb-0">{{ $t("partialPayment.moreInfo") }}</h3>
        </div>
      </v-card-title>

      <v-card-text class="pb-1">
        <span class="accent--text">{{
          $t("partialPayment.descriptionTitle")
        }}</span>
      </v-card-text>

      <v-card-text class="pb-1 pt-1">
        <span class="accent--text">{{
          $t("partialPayment.descriptionOne")
        }}</span>
      </v-card-text>

      <v-card-text class="pb-1 pt-1">
        <span class="accent--text">{{
          $t("partialPayment.descriptionTwo")
        }}</span>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn
          height="40"
          width="100"
          color="primary"
          outlined
          rounded
          @click="$emit('closeDialog')"
          >{{ $t("partialPayment.close") }}</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-row>
</template>

<script>
export default {};
</script>
